import { useState } from "react";
import { SalaryInputCard } from "./components/salaryInput";
import { SalaryResponse } from "./components/salaryResponse";
import type { SalaryResultsType } from "./salario-liquido";

export default function SalarioLiquido() {
  const [results, setResults] = useState<SalaryResultsType | null>(null);

  return (
    <div className="max-w-4xl mx-auto p-4">
      <SalaryInputCard setResults={setResults} />
      {results && <SalaryResponse results={results} />}
    </div>
  );
}